import { Injectable } from "@angular/core";

import { BaseGetProvider } from "@tendercuts/http";
import { LocationPing } from "@tendercuts/models";

import { HttpClient, HttpParams } from "@angular/common/http";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";

@Injectable()
export class OrderLocationService extends BaseGetProvider<LocationPing> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof LocationPing {
    return LocationPing;
  }

  get endpoint(): string {
    return this.endpointService.orderLocation();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(tripId: string): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append("trip_id", tripId);

    return params;
  }
}
